"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdventureHandlers = exports.RoomScripts = exports.EventHandlers = exports.EventHandlerScripts = exports.Effects = exports.Ai = exports.ActorAbilities = exports.Actions = exports.Abilities = void 0;
const AbilityType_1 = require("../abilities/AbilityType");
const ActionType_1 = require("../actions/ActionType");
const EffectType_1 = require("../effects/EffectType");
const EventHandlerType_1 = require("../event-handlers/EventHandlerType");
const AutoRegistry_1 = require("../../utils/AutoRegistry");
exports.Abilities = (0, AutoRegistry_1.mkAutoRegistry)(AbilityType_1.AbilityType);
exports.Actions = (0, AutoRegistry_1.mkAutoRegistry)(ActionType_1.ActionType);
exports.ActorAbilities = (0, AutoRegistry_1.mkAutoRegistry)({});
exports.Ai = (0, AutoRegistry_1.mkAutoRegistry)({});
exports.Effects = (0, AutoRegistry_1.mkAutoRegistry)(EffectType_1.EffectType);
exports.EventHandlerScripts = (0, AutoRegistry_1.mkAutoRegistry)({});
exports.EventHandlers = (0, AutoRegistry_1.mkAutoRegistry)(EventHandlerType_1.EventHandlerType);
exports.RoomScripts = (0, AutoRegistry_1.mkAutoRegistry)({});
exports.AdventureHandlers = (0, AutoRegistry_1.mkAutoRegistry)({});
